import { render, staticRenderFns } from "./ExpiredTrigger.vue?vue&type=template&id=19838cbb"
import script from "./ExpiredTrigger.vue?vue&type=script&lang=js"
export * from "./ExpiredTrigger.vue?vue&type=script&lang=js"
import style0 from "./ExpiredTrigger.vue?vue&type=style&index=0&id=19838cbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports